export default "__VITE_ASSET__DMWoZXlD__"